import { NgModule } from '@angular/core';
import { ZcSampleMenuComponent } from './zc-sample-menu.component';

@NgModule({
  imports: [
  ],
  declarations: [ZcSampleMenuComponent],
  exports: [ZcSampleMenuComponent]
})
export class ZcSampleMenuModule { }
